import App from './speedtest/Index.svelte';

const app = new App({
	target: document.getElementById("page_body"),
	props: {}
});

export default app;
